/* ==============================================================================================
 * [ACCESS] LOAN SEARCH RESULTS TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	// TODO: Update API endpoint URLs
	var loansApiEndpoint = "/json/access/loanSearchResults.json";
	var dealsApiEndpoint = "/json/access/loanDealIssues.json";

	var tableElement = document.querySelector("#loanSearchResultsTable");

	if (!tableElement) {
		return;
	}

	var loansTableColumns = [
		{
			data: "dealCusip",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "borrowerName",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: "creditAgreementDate",
			className: "c-table__cell",
			searchable: true,
		},
		{
			data: null,
			orderable: false,
			className: "c-table__cell c-table__cell--expand",
			defaultContent: "",
		},
	];

	var loansTableColumnDefs = [
		{
			targets: [ 1 ],
			render: function (data) {
				return "<a data-plugin='DealDetail' "
					+ "href='#' "
					+ "data-issuer-number='" + data + "' "
					+ ">" + data + "</a>";
			},
		},
		{
			targets: [ 3 ],
			width: "1%",
			orderable: false,
		},
	];

    var getDealsTable = function () {
        return CGS.createTableHtml({
			files: true,
			head: {
				rows: [{
					cells: [
						{ content: "" },
						{ content: "Borrower Number" },
						{ content: "Facility CUSIP" },
						{ content: "ISIN" },
						{ content: "Facility Purpose" },
						{ content: "Maturity" },
						{ content: "Facility Amount" },
						{ content: "ISO Currency" },
						{ content: "Facility Type" },
					],
				}],
			},
		});
	};

    var dealsTableColumns = [
        {
            data: null,
            orderable: false,
            className: "c-table__cell c-table__cell--checkbox",
        },
		{
			data: "facilityBorrowerNumber",
			className: "c-table__cell",
			searchable: true,
		},
        {
            data: null,
            className: "c-table__cell",
            searchable: true,
        },
        {
            data: "issueIsinNumber",
            className: "c-table__cell",
            searchable: true,
        },
		{
			data: "facilityPurpose",
			className: "c-table__cell",
			searchable: true,
		},
        {
            data: "issueMaturityDate",
            className: "c-table__cell",
            searchable: true,
        },
        {
            data: "amount",
            className: "c-table__cell",
            searchable: true,
        },
        {
            data: "isoCurrencyCode",
            className: "c-table__cell",
            searchable: true,
        },
        {
            data: "facilityType",
            className: "c-table__cell",
            searchable: true,
        },
    ];

    var dealsTableColumnDefs = [
        {
            targets: [ 0 ],
            render: function (data) {
				return CGS.renderFileExportCheckCell(data["issueIsinNumber"]);
			},
        },
        {
            targets: [ 2 ],
            render: function (data) {
				return "<a data-plugin='DealDetail' "
                        + "href='#' "
                        + "data-issuer-number='" + data["issuerNumber"] + "' "
                        + ">" + data["issueNumber"] + " " + data["issueCheck"] + "</a>";
            },
        },
	];

	CGS.table(tableElement, {
		ajax: loansApiEndpoint,
		columns: loansTableColumns,
		columnDefs: loansTableColumnDefs,
		createdRow: function (row) {
			row.classList.add("c-table__row--expand");
		},
		initComplete: function (settings, json) {
			CGS.setupChildTables(settings, json, {
				ajax: {
					url: dealsApiEndpoint,
					dataSrc: function (json) {
						var deals = json["facilityDetailList"];

						deals = deals.map(function (data) {
							data.issuerNumber = json.issuerNumber;

							return data;
						});

						return deals;
					},
				},
				columns: dealsTableColumns,
				columnDefs: dealsTableColumnDefs,
				tableFn: getDealsTable,
			});
		},
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
